import { render, staticRenderFns } from "./ClientTasks.vue?vue&type=template&id=737eaef2"
import script from "./ClientTasks.vue?vue&type=script&lang=ts"
export * from "./ClientTasks.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports